<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Descrição</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cid in cids" :key="cid._id">
          <td>{{ cid.descricaoAbreviada }}</td>
          <td>{{ cid.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              id="botaoEditar"
              v-tooltip="'Editar'"
              data-test-id="link-botaoeditar"
              :to="'/cid/cadastro/' + cid._id"
              name="botaoEditar"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CidTabela',
  props: {
    cids: {
      type: Array,
      required: true,
    },
  },
}
</script>
